<template>
  <div class="app">
    <SideBar
      v-if="isAuthenticated"
      ref="sidebar"
      :isMobileSidebarOpen="isMobileSidebarOpen"
      :isMobile="isMobile"
      @sidebar-closed="handleSidebarClosed"
    />
    <div
      class="content-view"
      :style="{
        'padding-left': getContentPadding(),
      }"
    >
      <NavBar
        v-if="isAuthenticated"
        :isMobileSidebarOpen="isMobileSidebarOpen"
        :isMobile="isMobile"
        @toggle-sidebar="handleSidebarToggle"
      />
      <router-view />
      <img
        src="@/assets/icons/mascot-medium.svg"
        alt="mascota"
        :style="getStyles()"
        v-if="isInRoute()"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, onUpdated } from "vue";

import SideBar from "@/components/sidebar/SideBar.vue";
import NavBar from "@/components/navbar/NavBar.vue";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useRoute } from "vue-router";
import { useResponsive } from "@/services/responsive";

const route = useRoute();
const isAuthenticated = ref(false);
const sidebar = ref(null);

const {
  isMobile,
  isMobileSidebarOpen,
  toggleMobileSidebar,
  closeMobileSidebar,
} = useResponsive();

onMounted(async () => {
  isAuthenticated.value =
    !!localStorage.getItem("user_id") && route.path !== "/";
});

onUpdated(() => {
  isAuthenticated.value =
    !!localStorage.getItem("user_id") && route.path !== "/";
});

const isInRoute = () => {
  return (
    ["cursos", "curso", "claseView"].includes(route.name) && !isMobile.value
  );
};

const getStyles = () => {
  return {
    position: "fixed",
    bottom: "0",
    ...(route.name === "claseView"
      ? { left: 40, rotate: "0 1 0 180deg" }
      : { right: 0 }),
    margin: "1rem",
  };
};

const getContentPadding = () => {
  // If not authenticated or on login page, no padding
  if (!isAuthenticated.value || route.path === "/") {
    return "0";
  }

  // Check if we're on mobile (sidebar is hidden by default)
  if (isMobile.value) {
    // On mobile, no padding since sidebar is hidden
    return "0";
  }

  // On desktop, use sidebar width
  return "var(--sidebar-width)";
};

const handleSidebarToggle = (isOpen) => {
  if (isOpen) {
    toggleMobileSidebar();
  } else {
    closeMobileSidebar();
  }

  if (sidebar.value) {
    sidebar.value.toggleSidebar(isOpen);
  }
};

const handleSidebarClosed = () => {
  closeMobileSidebar();
  console.log("Sidebar closed");
};
</script>

<style lang="scss" src="./styles/app.scss"></style>
